<template>
  <div class="container px-1 px-md-4 py-5 mx-auto">
    <div class="card">
      <div class="d-flex justify-content-between px-3 top">
        <div class="d-flex">
          <h5>ORDER <span class="text-primary font-weight-bold">{{ orderNumber }}</span></h5>
        </div>
        <div class="d-flex flex-column text-sm-right">
          <p class="mb-0">Expected Arrival <span>{{ expectedArrival }}</span></p>
          <p>USPS <span class="font-weight-bold">{{ trackingNumber }}</span></p>
        </div>
      </div>

      <!-- Progress Bar -->
      <div class="row d-flex justify-content-center">
        <div class="col-12">
          <ul id="progressbar" class="text-center">
            <li v-for="(step, index) in steps" :key="index" :class="{'active': step.active, 'step0': true}"></li>
          </ul>
        </div>
      </div>

      <!-- Status Icons -->
      <!--      <div class="d-flex justify-content-center">-->
      <!--        <div v-for="(status, index) in statusIcons" :key="index" class="row d-flex icon-content">-->
      <!--          <img class="icon" :src="status.src" />-->
      <!--          <div class="d-flex flex-column">-->
      <!--            <p class="font-weight-bold">{{ status.label }}</p>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orderNumber: '#Y34XDHR',
      expectedArrival: '01/12/19',
      trackingNumber: '234094567242423422898',
      steps: [
        { active: false }, // Start with all inactive
        { active: false },
        { active: false },
        { active: false }
      ],
      statusIcons: [
        { src: 'https://i.imgur.com/9nnc9Et.png', label: 'Order Processed' },
        { src: 'https://i.imgur.com/u1AzR7w.png', label: 'Order Shipped' },
        { src: 'https://i.imgur.com/TkPm63y.png', label: 'Order En Route' },
        { src: 'https://i.imgur.com/HdsziHP.png', label: 'Order Arrived' }
      ]
    }
  },
  methods: {
    async fetchOrderStates() {
      // Simulated API response
      const simulatedResponse = {
        data: {
          states: {
            currentStep: 0 // Change this number to test different progress
          }
        }
      };

      // Use the simulated response instead of actual API call
      const states = simulatedResponse.data.states;

      // Update the steps based on the simulated response
      this.steps = this.steps.map((step, index) => ({
        active: index < states.currentStep + 1 // +1 to include current step
      }));
    }
  },
  mounted() {
    this.fetchOrderStates();
  }
}
</script>

<style scoped>
body {
  color: #000;
  overflow-x: hidden;
  height: 100%;
  background-color: #8C9EFF;
  background-repeat: no-repeat;
}

.card {
  width: 100%;
  z-index: 0;
  padding-bottom: 20px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.top {
  padding-top: 40px;
  padding-left: 13% !important;
  padding-right: 13% !important;
}

/* Progress Bar */
#progressbar {
  margin-bottom: 20px;
  overflow: hidden;
  color: #3A6898;
  padding-left: 0;
  margin-top: 10px;
}

#progressbar li {
  list-style-type: none;
  font-size: 13px;
  width: 25%;
  float: left;
  position: relative;
  font-weight: 400;
}

#progressbar .step0:before {
  font-family: FontAwesome;
  content: "\f10c";
  color: #fff;
}

#progressbar li:before {
  width: 40px;
  height: 40px;
  line-height: 45px;
  display: block;
  font-size: 20px;
  background: #0B66FF;
  border-radius: 50%;
  margin: auto;
  padding: 0;
}

#progressbar li:after {
  content: '';
  width: 100%;
  height: 12px;
  background: #0B66FF;
  position: absolute;
  left: 0;
  top: 16px;
  z-index: -1;
}

#progressbar li:last-child:after {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  position: absolute;
  left: -50%;
}

#progressbar li:nth-child(2):after, #progressbar li:nth-child(3):after {
  left: -50%;
}

#progressbar li:first-child:after {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  position: absolute;
  left: 50%;
}

#progressbar li:last-child:after {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

#progressbar li.active:before, #progressbar li.active:after {
  background: #0B66FF;
}

#progressbar li.active:before {
  font-family: FontAwesome;
  content: "\f00c";
}

.icon {
  display: none;
  border: solid;
  width: 60px;
  height: 40px;
  margin-right: 70px;
}

.icon-content {
  padding-bottom: 20px;
}

@media screen and (max-width: 992px) {
  .icon-content {
    width: 50%;
  }
}
</style>

